import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../../styles/admin/NewExamPage.css";
import axios from "axios";
import BASE_URL from "../../BaseUrl";
import ImageIcon from "../../../src/image icon.svg"
import CircularProgress from '@mui/material/CircularProgress'

export default function EditExam({setActive,setMobileActive, isAdmin}){
  const { examId } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("error message");
  const [showMessage, setShowMessage] = useState(false);
  const [loaded,setLoaded] = useState(false);
  const [questionsToDelete, setQuestionsToDelete] = useState([]);
  const [questionFiles, setQuestionFiles] = useState([]);
  const [disabledButton, setDisabledButton] = useState(false); 

  const [exam, setExam] = useState({
    id: "",
    name: "",
    unitId: "",
    uploadDate: null,
    senderId: "",
    finalGrade: 0,
  });

  const [oldQuestions, setOldQuestions] = useState([]);
  const [newQuestions,setNewQuestions] = useState([]);

  const addQuestion = () => {
    const newQuestion = {
      examId:examId,
      questionNumber: oldQuestions.length + newQuestions.length + 1,
      question: "",
      choice1: "",
      choice2: "",
      choice3: "",
      choice4: "",
      choice5: "",
      correctAnswer: null,
      grade: 1,
      photo:false
    };
    const updatedQuestions = [...newQuestions,newQuestion];
    setNewQuestions(updatedQuestions);
    updateFinalGrade([...updatedQuestions,...oldQuestions]);
  };

  const fileExtension = (file) => {
    const parts = file.name.split(".");
    return parts.length > 1 ? parts.pop().toLowerCase() : "";
  };

  const handleImageSelect = async (qIndex, file) => {
    const fileExtension1 = fileExtension(file);
    if(fileExtension1 === ""){
      alert("امتداد الملف غير مقبول");
      return;
    }
  const fileName = `${await getUUID()}.${fileExtension1}`
  const updated = [...newQuestions];
  updated[qIndex].image = URL.createObjectURL(file);
  updated[qIndex].question = `${fileName}`;
  updated[qIndex].photo = true;
  setNewQuestions(updated);
  setQuestionFiles([...questionFiles,{fileName:fileName,file:file}]);

};

  const deleteQuestion = (qindex,isOld)=>{
    if(isOld){
      const updatedQuestions = [...oldQuestions]
      const questionToDelete = updatedQuestions[qindex];
      updatedQuestions.splice(qindex,1);
      for(let i = qindex ; i < updatedQuestions.length; i++){
          updatedQuestions[i].questionNumber -=1;
      }
      const updatedNewQuestions = [...newQuestions];
      for(let i = 0; i< updatedNewQuestions.length; i++){
        updatedNewQuestions[i].questionNumber -= 1;
      }
      setNewQuestions(updatedNewQuestions);
      updateFinalGrade([...updatedQuestions,...newQuestions]);
      setQuestionsToDelete([...questionsToDelete,questionToDelete]);
      setOldQuestions(updatedQuestions);
    } else{
        const updatedQuestions = [...newQuestions];
        const updatedFiles = [...questionFiles];
        
        var fileIndex = -1;
        if(updatedQuestions[qindex].photo){
          const fileName = updatedQuestions[qindex].question;
          for(let i = 0; i< updatedFiles; i++){
            if(updatedFiles[i].fileName === fileName){
              fileIndex = i;
              break;
            }
          }
        }
        if(fileIndex !== -1){
          updatedFiles.splice(fileIndex,1);
          setQuestionFiles(updatedFiles);
        }
        updatedQuestions.splice(qindex,1);
        for(let i = qindex; i < updatedQuestions.length; i++){
          updatedQuestions[i].questionNumber -=1;
        }
        
        setNewQuestions(updatedQuestions);
        updateFinalGrade([...updatedQuestions,...oldQuestions]);
    }
  }
  
  const updateQuestionField = (index, value,isOld) => {
    if(isOld){
      const updated = [...oldQuestions];
      updated[index].question = value;
      setOldQuestions(updated);
    } 
    else{
      const updated = [...newQuestions];
      updated[index].question = value;
      setNewQuestions(updated);
    }
  };

  const updateChoice = (qIndex, cIndex, value,isOld) => {
    if(isOld){
      const updated = [...oldQuestions];
      updated[qIndex][`choice${cIndex + 1}`] = value;
      setOldQuestions(updated);
    }
    else{
      const updated = [...newQuestions];
      updated[qIndex][`choice${cIndex+1}`] = value;
      setNewQuestions(updated);
    }
  };

  const updateCorrectAnswer = (qIndex, value,isOld) => {
    if(isOld){
      const updated = [...oldQuestions];
      updated[qIndex].correctAnswer = updated[qIndex][`choice${value}`];
      setOldQuestions(updated);
    }
    else{
      const updated = [...newQuestions];
      updated[qIndex].correctAnswer = updated[qIndex][`choice${value}`];
      setNewQuestions(updated);
    }
  };

  const updateGrade = (qIndex, value,isOld) => {
    if(isOld){
      const updated = [...oldQuestions];
      updated[qIndex].grade = Number(value);
      setOldQuestions(updated);
      updateFinalGrade([...updated,...newQuestions]);
    }
    else{
      const updated = [...newQuestions];
      updated[qIndex].grade = Number(value);
      setNewQuestions(updated);
      updateFinalGrade([...updated,...oldQuestions]);
    }
  };

  async function getUUID(){
    try{
      const response = await axios.get(`${BASE_URL}/${isAdmin?"teacher":"assistant"}/UUID`,{withCredentials:true});
      return response.data;
    }catch(error){
      console.log(error);
    }
  }

  const updateTheExam = async()=>{
    setDisabledButton(true);
    let message = "";
    oldQuestions.map((q,index)=>{
      if(q.correctAnswer === "" || q.correctAnswer === null || q.correctAnswer === undefined){
        message+= `السؤال رقم ${index+1} ليس لديه اجابة صحيحة\n`
      }
      return "q";
    })
    if(message !== ""){
      alert(message);
      setDisabledButton(false);
      return;
    }
    if(exam.name === "" || exam.name === null || exam.name === undefined){
      alert("يجب تسمية الاختبار")
      setDisabledButton(false);
      return;
    }
    const questions = [...oldQuestions,...newQuestions];
    const formData = new FormData();
    formData.append("exam",new Blob(
      [JSON.stringify(exam)],
      { type: "application/json" }));
      formData.append("questions",new Blob(
      [JSON.stringify(questions)],
      { type: "application/json" }));
    questionFiles.forEach(({fileName,file}) =>{
      formData.append(fileName.toString(),file)
    });
    try{
      if(questionsToDelete.length>0){
        const deleteQuestionQuery = await axios.post(`${BASE_URL}/${isAdmin?"teacher":"assistant"}/delete-questions`,questionsToDelete,{withCredentials:true});
      }
      const response = await axios.put(`${BASE_URL}/${isAdmin?"teacher":"assistant"}/update-exam`,formData,{withCredentials:true});
      setMessage(response.data);
      setShowMessage(true);
      setDisabledButton(false);
    }catch (error){
      console.log(error);
      setDisabledButton(false);
    }
  }

  const updateFinalGrade = (updatedQuestions) => {
    const total = updatedQuestions.reduce((sum, q) => sum + Number(q.grade), 0);
    setExam({ ...exam, finalGrade: total });
  };

  const fetchData= async()=>{
    if(examId === "" || examId === null || examId === undefined){
      navigate(-1);
      return;
    }
    try{
      const response = await axios.get(`${BASE_URL}/${isAdmin?"teacher":"assistant"}/exam-details?examId=${examId}`,{withCredentials:true});
      setExam(response.data.exam);
      setOldQuestions(response.data.questions);
      setLoaded(true);
    } catch(error){
      console.log(error);
    }

  }

  useEffect(()=>{
    fetchData();
   setActive("المواد الدراسية");
   setMobileActive("courses mobile");
  },[]);

  return (
    <dvi>
      {loaded&&(<div className="page-container space-y-4">
        <div className="exam-info-card">
          <div><h2 className="new-exam">تعديل الاختبار</h2></div>
          <div className="exam-info">
          <input
            dir="rtl"
            lang="ar"
            placeholder="اسم الاختبار"
            value={exam.name}
            onChange={(e) => setExam({ ...exam, name: e.target.value })}
          />

          <p className="question-title">{exam.finalGrade}:مجموع الدرجات </p>
          <div className="exam-info-buttons">
            <button className="delete-lesson-button" onClick={()=>navigate(-1)}>إلغاء</button>
            <button 
              disabled={disabledButton}
              onClick={updateTheExam}>
              {disabledButton ? <CircularProgress size={20} color="white" /> : "حفظ التعديلات"}
            </button>
          </div>
          
          </div>
        </div>

        <div className="space-y-6">
          {oldQuestions.map((q, qIndex) => (
            <div key={qIndex} className="question-card">
                <h3 className="question-title"> {q.questionNumber}السؤال رقم </h3>

                {q.photo? 
                <div className="image-preview-container">
                <img className="question-image-preview" src={`${BASE_URL}/${isAdmin?"teacher":"assistant"}/image/${q.question}`} />
                </div>
                : <h4 >{q.question}</h4>}

                  {[1, 2, 3, 4, 5].map((num, cIndex) => (
                    <div key={cIndex} className="choice-row">
                      <input
                        dir="rtl"
                        lang="ar"
                        className="choice-input"
                        placeholder={`${num}اختيار رقم `}
                        value={q[`choice${num}`]}
                        onChange={(e) =>{
                          const isCorrect = q.correctAnswer === q[`choice${num}`];
                          updateChoice(qIndex, cIndex, e.target.value,true);
                          if(isCorrect) updateCorrectAnswer(qIndex,num,true);
                        }
                        }
                      />

                      <input
                        dir="rtl"
                        lang="ar"
                        className="choice-input-radio"
                        type="radio"
                        name={`correct-${qIndex}`}
                        checked={q.correctAnswer === q[`choice${num}`]}
                        onChange={() => {updateCorrectAnswer(qIndex, num,true);}}
                      />
                    </div>
                  ))}

                <div className="question-degree-div">
                  <button className="lesson-delete-button delete-question" onClick={(e)=>{
                  e.stopPropagation();
                  deleteQuestion(qIndex,true);
                }}>حذف</button>
                  <input
                  dir="rtl"
                  lang="ar"
                  type="number"
                  min={1}
                  className="grade-input"
                  placeholder="درجة السؤال"
                  value={q.grade}
                  onChange={(e) => updateGrade(qIndex, e.target.value,true)}
                />
                <h4> درجة السؤال</h4>

                </div>
              </div>
          ))}
          {newQuestions.map((q, qIndex) => (
          <div key={qIndex} className="question-card">
              <h3 className="question-title"> {q.questionNumber}السؤال رقم </h3>

              {!q.photo ?(
                <div className="image-upload-area">
                <label className="upload-icon">
                  <img style={{height:"30px"}} src={ImageIcon} />
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => handleImageSelect(qIndex, e.target.files[0])}
                  />
                </label>
                <textarea
                    className="question-text"
                    lang="ar"
                    dir="rtl"
                    placeholder="السؤال"
                    value={q.question}
                    onChange={(e) => updateQuestionField(qIndex, e.target.value)}
                  />
              </div>
              ): (
                  <div className="image-preview-container">
                    <img src={q.image} className="question-image-preview" alt="question" />
                  </div>
                )}


              {/* {!q.photo&&(
                <div className="image-upload-area">
                <label className="upload-icon">
                  📸
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => handleImageSelect(qIndex, e.target.files[0])}
                  />
                </label>
              </div>
              )}

              {!q.image ? (
                  <textarea
                    className="question-text"
                    lang="ar"
                    dir="rtl"
                    placeholder="السؤال"
                    value={q.question}
                    onChange={(e) => updateQuestionField(qIndex, e.target.value,false)}
                  />
                ) : (
                  <div className="image-preview-container">
                    <img src={q.image} className="question-image-preview" alt="question" />
                  </div>
                )} */}

                {[1, 2, 3, 4, 5].map((num, cIndex) => (
                  <div key={cIndex} className="choice-row">
                    <input
                      dir="rtl"
                      lang="ar"
                      className="choice-input"
                      placeholder={`${num}اختيار رقم `}
                      value={q[`choice${num}`]}
                      onChange={(e) =>{
                        const isCorrect = q.correctAnswer === q[`choice${num}`];
                        updateChoice(qIndex, cIndex, e.target.value,false);
                        if(isCorrect) updateCorrectAnswer(qIndex,num,false);
                      }
                      }
                    />

                    <input
                      className="choice-input-radio"
                      type="radio"
                      name={`new-correct-${qIndex}`}
                      checked={q.correctAnswer === q[`choice${num}`]}
                      onChange={() => {updateCorrectAnswer(qIndex, num,false);}}
                    />
                  </div>
                ))}

                

              <div className="question-degree-div">
                <button className="lesson-delete-button delete-question" onClick={(e)=>{
                  e.stopPropagation();
                  deleteQuestion(qIndex,false);
                }}>حذف</button>
                <input
                type="number"
                min={1}
                className="grade-input"
                placeholder="درجة السؤال"
                value={q.grade ===0?null:q.grade}
                onChange={(e) => updateGrade(qIndex, e.target.value,false)}
              />
              <h4> درجة السؤال</h4>

              </div>
            </div>
        ))}
        </div>
        <div className="new-question-button-div">
          <button className="new-question-button" style={{marginBottom:"20px",marginLeft:"0px",marginRight:"0px"}} onClick={addQuestion}>سؤال جديد</button>
        </div>
        { showMessage && (
                      <div className="overlay">
                          <div className="home-owner-message">
                              <p>{message}</p>
                              <button onClick={() => {setShowMessage(false);navigate(`/${isAdmin?"admin-home":"assistant-home"}/preview-exam/${examId}`,{replace: true})}}>اغلاق</button>
                          </div>
                      </div>
              )}
      </div>)}
    </dvi>
  );
}
